// https://github.com/moment/moment/issues/3650
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function interopDefault(m) {
    return m.default || m;
}
